import React, { useContext, useState } from "react";
import Vehicle from "../components/Vehicle";
import AppContext from "../context";
import swal from "sweetalert2";
import axios from "axios";
import { Trans, useTranslation } from "react-i18next";

export default function CarBrainModal({ a, k }) {
	const { setModal } = useContext(AppContext);
	const [damage, setDamage] = useState(a.vehicles[k]?.damage_area_1 || "");
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [ajax, setAjax] = useState(false);
	const v = a.vehicles[k];
	const { t, i18n } = useTranslation();

	const getVehicleName = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return (
				(a.vehicles[k].vehicle_maker ? a.vehicles[k].vehicle_maker : "") +
				(a.vehicles[k].vehicle_model_year
					? " " + a.vehicles[k].vehicle_model_year
					: "")
			);
		}
		// return "Unknown vehicle";
	};

	const getVin = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].vin_code;
		}
		// return "";
	};

	const getZip = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].owner_zip;
		}
		// return "";
	};

	const getFault = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			if (
				a.vehicles[k].contributing_factor1 &&
				a.vehicles[k].contributing_factor1 !== "N" &&
				a.vehicles[k].contributing_factor1 !== "NONE"
			)
				return true;
			// else return false;
		}
	};

	const submit = (e) => {
		e.preventDefault();
		setAjax(true);

		gtag("event", "page_view", {
			page_title: "Success",
			page_location: window.location.href,
			page_path: "/car-brain/success"
		});

		const headers = {
			'page-referrers': window.location.href
		}

		axios
			.post("/leads/create", {
				firstName: name.split(" ")[0],
				lastName: name.split(" ")[1],
				phone,
				email,
				accidentId: a.custom_id,
				legal_consult: false,
				fault: getFault(),
				injured:
					a.vehicles[k].participants[0] &&
					a.vehicles[k].participants[0].injury !== "NOT INJURED"
						? true
						: false,
				source: "carbrain",
				occupant: getVehicleName(),
				vin: getVin(),
				zip: getZip(),
				state: a.state,
				damage,
				language: i18n.language,
				trusted_form_cert: window.cert?.xxTrustedFormCertUrl || "",
				gclidcrm: window.gclidcrm || "",
			}, { headers })
			.then((d) => {
				if (d.data.success) {
					gtag("event", "car-success", {
						event_category: "car",
						event_label: "car-success-hot"
					});

					swal.fire(
						t("THANK_YOU"),
						t("THANK_YOU_FOR_REQUESTING_CARBRAIN"),
						"success"
					);
					setModal("");
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			})
			.catch((e) => {
				if (e.response.data.error === "blacklisted") {
					swal
						.fire(
							"Error",
							t("YOU_ARE_COMMERCIAL_USER__PLEASE_SIGN_UP_FOR_BUSINESS_SERVICE"),
							"warning"
						)
						.then(() => {
							window.location.href = "https://business.myaccident.org";
						});
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			});
	};
	return (
		<div id="car-brain" className={ajax ? "ajax" : ""}>
			<a className="close" onClick={() => setModal("")}>
				<img src="/assets/icon-close.png" alt="close" />
			</a>
			<div className="content">
				<h1>{t("YOUR_DAMAGED_CAR_MAY_BE_WORTH_MORE_THAN_YOU_THINK_")}</h1>
				<br />
				<br />
				<img
					src="https://cdn.carbrain.com/General/CB-Logo-Market-300-Width.png"
					height="65"
				/>
				<div className="row">
					<div style={{ textAlign: "right" }}>
						<img
							src="https://cdn.carbrain.com/General/Sell-Your-Car-Online.png"
							width="100%"
							style={{ maxWidth: 500 }}
						/>
					</div>
					<ul>
						<li>
							<img src="/assets/checked.png" alt="checked" />
							<em>{t("GUARANTEED_OFFER_ON_YOUR_CAR_")}</em>
						</li>
						<li>
							<img src="/assets/checked.png" alt="checked" />
							<em>
								<Trans i18nKey={"WE_COME_TO_YOUR_HOME"} />
							</em>
						</li>
						<li>
							<img src="/assets/checked.png" alt="checked" />
							<em>
								<Trans i18nKey={"FREE_TOWING"} />
							</em>
						</li>
						<li>
							<img src="/assets/checked.png" alt="checked" />
							<em>{t("NO_OBLIGATION_AND_HASSLE_FREE_")}</em>
						</li>
						<li>
							<img src="/assets/checked.png" alt="checked" />
							<em>
								<Trans i18nKey={"FAST_PROFESSIONAL_SERVICE"} />
							</em>
						</li>
					</ul>
				</div>
				<div
					className="row"
					style={{
						maxWidth: 800,
						margin: "40px auto",
						alignItems: "flex-start"
					}}
				>
					<div>
						<h3>
							{v.vehicle_maker} {v.vehicle_model_year}
						</h3>
						<Vehicle v={v} alt />
					</div>
					<div>
						<form onSubmit={(e) => submit(e)}>
							{v.vin_code ? (
								<>
									<label>VIN</label>
									<input type="text" disabled value={v.vin_code} />
								</>
							) : null}
							<label>{t("MODEL_YEAR_COLOR")}</label>
							<input
								type="text"
								disabled
								value={
									v.vehicle_maker +
									" " +
									v.vehicle_model_year +
									" " +
									v.vehicle_color
								}
							/>
							<label>{t("DAMAGE")}</label>
							<textarea
								value={damage}
								onChange={(e) => setDamage(e.target.value)}
							/>
							<label>{t("NAME")}</label>
							<input
								type="text"
								value={name}
								onChange={(e) => setName(e.target.value)}
								required
							/>
							<label>Em{t("")}ail</label>
							<input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
							<label>{t("CELL_PHONE")}</label>
							<input
								type="text"
								value={phone}
								onChange={(e) => setPhone(e.target.value)}
								required
							/>
							<button
								type="submit"
								style={{ float: "right" }}
								disabled={!name || !email || !phone}
							>
								{t("SUBMIT")}
							</button>
						</form>
						<small>
							{t("BY_SUBMITTING_THIS_REQUEST")}{" "}
							<a href="https://myaccident.org/terms-of-use" target="_blank">
								{t("TERMS_OF_USE")}
							</a>
							.
						</small>
					</div>
				</div>
				<h2>{t("HOW_IT_WORKS")}</h2>
				<div
					className="row"
					style={{
						justifyContent: "space-evenly",
						alignItems: "baseline",
						maxWidth: 900,
						margin: "40px auto"
					}}
				>
					<div style={{ textAlign: "center", padding: "20px", flex: "1 1 0%" }}>
						<img
							src="https://cdn.carbrain.com/Skins/7/enterDetails.png"
							width={200}
						/>
						<br />
						<br />
						<strong style={{ color: "rgb(52, 152, 219)", fontSize: "18px" }}>
							{t("ENTER_VEHICLE_DETAILS")}
						</strong>
						<br />
						{t(
							"MYACCIDENT_ORG_WILL_SHARE_YOUR_VEHICLE_AND_ACCIDENT_DETAILS_WITH_CARBRAIN"
						)}
					</div>
					<div style={{ textAlign: "center", padding: "20px", flex: "1 1 0%" }}>
						<img
							src="https://cdn.carbrain.com/Skins/7/acceptOffer.png"
							width={200}
						/>
						<br />
						<br />
						<strong style={{ color: "rgb(52, 152, 219)", fontSize: "18px" }}>
							{t("ACCEPT_YOUR_OFFER")}
						</strong>
						<br />
						{t("CARBRAIN_WILL_SEND_YOU_AN_OFFER")}
					</div>
					<div style={{ textAlign: "center", padding: "20px", flex: "1 1 0%" }}>
						<img
							src="https://cdn.carbrain.com/Skins/7/getPaidNew2.png"
							width={200}
						/>
						<br />
						<br />
						<strong style={{ color: "rgb(52, 152, 219)", fontSize: "18px" }}>
							{t("GET_PAID_")}
						</strong>
						<br />
						{t("CARBRAIN_WILL_PICK_UP_YOUR_VEHICLE_AND_GIVE_YOU_CASH_")}
					</div>
				</div>
				<br />
				<img src="/assets/car-brain-ratings.png" width="100%" />
			</div>
		</div>
	);
}
